import { render } from "./Zusatzunterkunft2.vue?vue&type=template&id=4f17aece&scoped=true"
import script from "./Zusatzunterkunft2.vue?vue&type=script&lang=js"
export * from "./Zusatzunterkunft2.vue?vue&type=script&lang=js"

import "./Zusatzunterkunft2.vue?vue&type=style&index=0&id=4f17aece&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f17aece"]])

export default __exports__